var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import useFieldApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-field-api";
import { usePresentationComponent } from "../../../AppContext";
import { Checkbox } from "../Checkbox/Checkbox";
import { getClassName } from "../../../helpers";
var MENU_ITEM = "ws-menu-item";
var MENU_CHECKBOX = "ws-menu-checkbox";
var MenuItemRenderer = function (_a) {
    var caption = _a.caption, icon = _a.icon, className = _a.className, rest = __rest(_a, ["caption", "icon", "className"]);
    return (React.createElement("div", __assign({ className: getClassName(MENU_ITEM, className) }, rest),
        icon,
        caption));
};
export var MenuItem = styled(MenuItemRenderer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:hover {\n        background: #f5f5f5;\n    }\n    & + & {\n        border-top: 1px solid #ccc;\n    }\n    .", " {\n        margin-bottom: 0;\n        padding: .5em;\n    }\n"], ["\n    &:hover {\n        background: #f5f5f5;\n    }\n    & + & {\n        border-top: 1px solid #ccc;\n    }\n    .", " {\n        margin-bottom: 0;\n        padding: .5em;\n    }\n"])), MENU_CHECKBOX);
var MenuItemComponent = function (_a) {
    var name = _a.name, _b = _a.input, value = _b.value, input = __rest(_b, ["value"]), context = _a.context, caption = _a.caption, showCheckbox = _a.showCheckbox, className = _a.className, props = __rest(_a, ["name", "input", "context", "caption", "showCheckbox", "className"]);
    var Component = usePresentationComponent([context + ".menuItem", "menuItem"]) || MenuItem;
    return React.createElement(Component, { className: className, context: context, disabled: props.disabled, caption: showCheckbox ? "" : caption, icon: showCheckbox ? React.createElement(MenuCheckbox, __assign({ checked: value, input: input, label: caption, name: name }, props, { className: getClassName(MENU_CHECKBOX, props.className) })) : null });
};
export var ReactiveMenuItem = function (props) {
    var input = useFieldApi(props).input;
    return React.createElement(MenuItemComponent, __assign({}, props, { input: input }));
};
export var MenuCheckbox = styled(Checkbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: 0;\n    padding: 10px 15px;\n    * { cursor: pointer !important; }\n    label { margin-bottom: 0; }\n    ", ":last-of-type & {\n        margin-bottom: 0;\n    }\n"], ["\n    margin-bottom: 0;\n    padding: 10px 15px;\n    * { cursor: pointer !important; }\n    label { margin-bottom: 0; }\n    ", ":last-of-type & {\n        margin-bottom: 0;\n    }\n"])), MenuItem);
var templateObject_1, templateObject_2;
